import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common from "@/locales/en/common.json";

void i18n.use(initReactI18next).init({
  resources: { en: { common } },
  lng: "en",
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export default i18n;
